// Registry of proposals: code -> loader. This is the ONLY place that lists proposals.
// Each entry is a dynamic import, so a client's data is downloaded only when their code is requested.
// Add a line per client (see /ADD-A-PROPOSAL.md). Never remove a code once it has been shared;
// set the proposal's meta.status to "expired" or "withdrawn" instead.
export const proposals = {
  "dennis-k7m2": () => import(/* webpackChunkName: "p-dennis-k7m2" */ "./dennis-k7m2.js"),
};

export const hasProposal = (code) => Object.prototype.hasOwnProperty.call(proposals, code);
